import { useQuery } from "@apollo/client";
import {
  GetPayPeriodEndDatesQueryVariables,
  GetPayPeriodPaymentExpectedOnDatesQuery,
} from "generated/graphql";
import queries from "Shared/queries";
import { usePresettlementExclusionsHook } from "./PresettlementExclusionsTable/usePresettlementExclusionsHook";

export const usePayPeriodExpectedDates = () => {
  const { onDefaultPayDateChange } = usePresettlementExclusionsHook();
  const { data } = useQuery<
    GetPayPeriodPaymentExpectedOnDatesQuery,
    GetPayPeriodEndDatesQueryVariables
  >(queries.GET_PAY_PERIOD_PAYMENT_EXPECTED_ON_DATES, {
    onCompleted: (data) => {
      const expectedDates =
        data?.employer.currentProvider.payPeriodPaymentExpectedOnDates;
      onDefaultPayDateChange(expectedDates[0]);
    },
  });

  return {
    expectedDates:
      data?.employer.currentProvider.payPeriodPaymentExpectedOnDates,
  };
};
